function removeHtmlTags(htmlText: string) {
  if (!htmlText || typeof htmlText != "string") {
    return "";
  }

  const regex = /<[^>]+>/g; // Expresión regular para encontrar todas las etiquetas HTML
  const plainText =
    htmlText?.replace(regex, " ")?.replace(/\s+/g, " ")?.trim() || "";

  return plainText;
}

export default removeHtmlTags;
